import { Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';

export const IssuesTabHeader = ({
  title,
  description,
  hint
}: {
  title: string;
  description?: string;
  hint?: ReactNode;
}) => (
  <Stack gap={0.75}>
    <Typography fontWeight={700} fontSize={18} color="#226AAA">
      {title}
    </Typography>
    {description ? (
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 960 }}>
        {description}
      </Typography>
    ) : null}
    {hint}
  </Stack>
);
